export default "__VITE_ASSET__30097c45__"